import apiConfig from "./ApiURL.json";
var apiEndpoint = process.env.VUE_APP_TOKO_API || apiConfig.stockopname;
import App from "./App/App.js";

export default {
  getDetails(id, params) {
    let options = {
      cid: App.Session.getCompanyID(),
      id: id,
      uid: App.Session.getUserID()
    };
    options = Object.assign(options, params);
    const attributes = ["cid", "id", "uid"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockadj/details/" + urlParams
    };
  },
  getDetailsData(id, params) {
    let options = {
      cid: App.Session.getCompanyID(),
      id: id,
      uid: App.Session.getUserID()
    };
    options = Object.assign(options, params);
    const attributes = ["cid", "id", "uid", "withcompany"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockadj/detailsdata" + urlParams
    };
  },
  getList(params) {
    let options = { cid: App.Session.getCompanyID(), uid: App.Session.getUserID() };
    options = Object.assign(options, params);
    const attributes = ["cid", "uid", "search", "warehouse", "field",
      "startdate", "enddate"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockadj/list" + urlParams
    };
  },
  getListData() {
    let options = { cid: App.Session.getCompanyID(), uid: App.Session.getUserID() };
    const attributes = ["cid", "uid"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockadj/listdata" + urlParams
    };
  },
  postData(data) {
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/warehouse/items/stockAdj",
      data: data
    };
  }
}